// extracted by mini-css-extract-plugin
export default {"col":"DataTableRow_col__TdESa","row":"DataTableRow_row__k8vDG","badge":"DataTableRow_badge__r02pM"};